// i18n.js — Détection de langue par origine du navigateur (FR → français, sinon anglais).
// Léger, sans dépendance. La langue est figée au chargement (origine utilisateur),
// avec surcharge possible via ?lang=fr|en ou localStorage (petit sélecteur en pied).

const DICT = {
  fr: {
    // Navigation
    'nav.home': 'Accueil', 'nav.games': 'Jeux', 'nav.videos': 'Vidéos',
    'nav.channels': 'Chaînes', 'nav.about': 'Écosystème', 'nav.support': 'Support',
    'nav.embed': 'Intégrer', 'nav.leaderboards': 'Classements',
    'nav.community': 'Communauté', 'nav.online': 'En ligne',
    'nav.palettes': '🎬 Crée ta palette', 'nav.palettesCourt': '🎬 Palettes', 'nav.premium': '✨ Premium',
    'nav.account': 'Mon espace', 'nav.login': 'Connexion',
    // Home
    'home.eyebrow': 'VertinGo Store — l’écosystème VertinGo',
    'home.title1': 'Joue, regarde,', 'home.title2': 'rejoins la communauté',
    'home.sub': 'Des jeux gratuits jouables direct dans le navigateur, trois chaînes YouTube et une communauté active. Ton point de départ pour tout l’univers VertinGo.',
    'home.browse': 'Découvrir les jeux', 'home.watch': 'Voir les vidéos',
    'home.stats.games': 'Jeux', 'home.stats.channels': 'Chaînes YouTube', 'home.stats.rating': 'Note moyenne',
    'home.featured': 'Jeux à la une', 'home.allGames': 'Tous les jeux',
    'home.ourChannels': 'Nos chaînes', 'home.allChannels': 'Toutes les chaînes',
    'home.joinTitle': 'Rejoins l’aventure VertinGo',
    'home.joinSub': 'Abonne-toi, rejoins le Discord et découvre l’écosystème complet.',
    'home.discoverEco': 'Découvrir l’écosystème',
    // Community / social
    'cta.subscribe': 'S’abonner', 'cta.subscribeYt': 'S’abonner sur YouTube',
    'cta.discord': 'Rejoindre le Discord', 'cta.share': 'Partager',
    // Newsletter
    'nl.title': 'Ne rate rien de VertinGo',
    'nl.sub': 'Nouveaux jeux, nouvelles vidéos, coulisses — reçois l’essentiel par email.',
    'nl.placeholder': 'ton@email.com', 'nl.button': 'Je m’abonne',
    'nl.ok': 'Inscription confirmée, merci !', 'nl.err': 'Un souci est survenu, réessaie.',
    'nl.invalid': 'Email invalide.',
    // Embed page
    'embed.title': 'Intègre le contenu VertinGo',
    'embed.sub': 'Copie-colle ces widgets sur ton site, ton blog ou celui d’un ami pour propager l’écosystème. Chaque intégration = du trafic en plus.',
    'embed.copy': 'Copier le code', 'embed.copied': 'Code copié !',
    'embed.preview': 'Aperçu', 'embed.code': 'Code à intégrer',
    'footer.language': 'Langue',
  },
  en: {
    'nav.home': 'Home', 'nav.games': 'Games', 'nav.videos': 'Videos',
    'nav.channels': 'Channels', 'nav.about': 'Ecosystem', 'nav.support': 'Support',
    'nav.embed': 'Embed', 'nav.leaderboards': 'Leaderboards',
    'nav.community': 'Community', 'nav.online': 'Online',
    'nav.palettes': '🎬 Create your palette', 'nav.palettesCourt': '🎬 Palettes', 'nav.premium': '✨ Premium',
    'nav.account': 'My space', 'nav.login': 'Sign in',
    'home.eyebrow': 'VertinGo Store — the VertinGo ecosystem',
    'home.title1': 'Play, watch,', 'home.title2': 'join the community',
    'home.sub': 'Free games playable right in your browser, three YouTube channels and an active community. Your gateway to the whole VertinGo universe.',
    'home.browse': 'Browse games', 'home.watch': 'Watch videos',
    'home.stats.games': 'Games', 'home.stats.channels': 'YouTube channels', 'home.stats.rating': 'Avg rating',
    'home.featured': 'Featured games', 'home.allGames': 'All games',
    'home.ourChannels': 'Our channels', 'home.allChannels': 'All channels',
    'home.joinTitle': 'Join the VertinGo adventure',
    'home.joinSub': 'Subscribe, join the Discord and explore the whole ecosystem.',
    'home.discoverEco': 'Explore the ecosystem',
    'cta.subscribe': 'Subscribe', 'cta.subscribeYt': 'Subscribe on YouTube',
    'cta.discord': 'Join the Discord', 'cta.share': 'Share',
    'nl.title': 'Never miss VertinGo news',
    'nl.sub': 'New games, new videos, behind the scenes — get the essentials by email.',
    'nl.placeholder': 'you@email.com', 'nl.button': 'Subscribe',
    'nl.ok': 'Subscription confirmed, thanks!', 'nl.err': 'Something went wrong, try again.',
    'nl.invalid': 'Invalid email.',
    'embed.title': 'Embed VertinGo content',
    'embed.sub': 'Copy-paste these widgets on your site, blog or a friend’s to spread the ecosystem. Every embed brings more traffic.',
    'embed.copy': 'Copy code', 'embed.copied': 'Code copied!',
    'embed.preview': 'Preview', 'embed.code': 'Embed code',
    'footer.language': 'Language',
  },
};

function detectLocale() {
  try {
    const params = new URLSearchParams(window.location.search);
    const q = params.get('lang');
    if (q && DICT[q]) { window.localStorage.setItem('vg_lang', q); return q; }
    const saved = window.localStorage.getItem('vg_lang');
    if (saved && DICT[saved]) return saved;
    const nav = (navigator.language || navigator.userLanguage || 'en').toLowerCase();
    return nav.startsWith('fr') ? 'fr' : 'en';
  } catch {
    return 'fr';
  }
}

export const locale = detectLocale();

export function t(key) {
  return (DICT[locale] && DICT[locale][key]) || DICT.en[key] || key;
}

export function setLocale(l) {
  if (!DICT[l]) return;
  try { window.localStorage.setItem('vg_lang', l); } catch { /* ignore */ }
  window.location.reload();
}

export const availableLocales = Object.keys(DICT);
